export default __webpack_public_path__ + "static/media/group.ee125b27.png";